"use strict";

exports.__esModule = true;
exports.CreateTicketDialog = void 0;
var _core = require("@blueprintjs/core");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _API = require("../../../API");
var _constants = require("../../../Auth/constants");
var _Core = require("../../../Core");
var _DeviceListContext = require("../../../Device/DeviceListContext");
var _DeviceTagListContext = require("../../../Device/DeviceTagListContext");
var _Env = require("../../../Env");
var _Logbook = require("../../../Logbook");
var _Theme = require("../../../Theme");
var _TicketTypes = require("../../../TicketTypes");
var _Time = require("../../../Time");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var StyledTab = (0, _styledComponents["default"])(_core.Tabs).withConfig({
  displayName: "CreateTicketDialog__StyledTab",
  componentId: "sc-fh1ke2-0"
})([".bp6-tab-list{margin-left:15px;}"]);
var TicketDialog = (0, _styledComponents["default"])(_core.Dialog).withConfig({
  displayName: "CreateTicketDialog__TicketDialog",
  componentId: "sc-fh1ke2-1"
})(["&.", "{box-shadow:none;}width:auto;"], _core.Classes.DIALOG);
var TicketWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CreateTicketDialog__TicketWrapper",
  componentId: "sc-fh1ke2-2"
})(["background-color:", ";padding-left:0px;padding-right:0px;padding-top:10px;min-width:600px;border-radius:10px;"], (0, _Theme.val)("LogBookNewEventBackground"));
var getSelectedTab = function getSelectedTab(licence) {
  if (licence.accessRights.includes(_constants.ACCESS_RIGHT_TICKETING)) {
    return "CREATE_TICKET";
  } else {
    return "CREATE_COMMENT";
  }
};
var formatDevices = function formatDevices(devices) {
  return devices.map(function (device) {
    return {
      type: "UUID",
      value: device.uuid
    };
  });
};
var formatTags = function formatTags(tags) {
  return tags.map(function (tag) {
    return {
      type: "TAG",
      value: tag
    };
  });
};
var CreateTicketDialog = exports.CreateTicketDialog = function CreateTicketDialog(props) {
  var api = _react["default"].useContext(_API.RestAPIContext);
  var isSidebarExpanded = props.isSidebarExpanded,
    isOpen = props.isOpen,
    onClose = props.onClose;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var _React$useContext2 = _react["default"].useContext(_Env.EnvContext),
    licence = _React$useContext2.licence;
  var _useState = (0, _react.useState)(getSelectedTab(licence)),
    selectedTabId = _useState[0],
    setSelectedTabId = _useState[1];
  var _React$useContext3 = _react["default"].useContext(_Time.TimeContext),
    timezone = _React$useContext3.timezone;
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var deviceTags = _react["default"].useContext(_DeviceTagListContext.DeviceTagListContext);
  var ticketTypesData = _react["default"].useContext(_TicketTypes.TicketTypeListContext);
  var _useState2 = (0, _react.useState)([]),
    filteredTicketTypes = _useState2[0],
    setFilteredTicketTypes = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    otherTicketTypes = _useState3[0],
    setOtherTicketTypes = _useState3[1];
  var userHasTicketingAccess = licence.accessRights.includes(_constants.ACCESS_RIGHT_TICKETING);
  (0, _react.useEffect)(function () {
    var getFilteredTypes = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var filteredTypes, allTicketTypes;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.post("/api/v1/ticketing/filter-ticket-types", {
                devices: [].concat(formatDevices(devices), formatTags(deviceTags)),
                timezone: timezone.name
              });
            case 1:
              filteredTypes = _context.v;
              allTicketTypes = ticketTypesData.getFiltered();
              setFilteredTicketTypes(allTicketTypes.filter(function (ticketType) {
                return filteredTypes.includes(ticketType.id);
              }));
              setOtherTicketTypes(allTicketTypes.filter(function (ticketType) {
                return !filteredTypes.includes(ticketType.id);
              }));
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getFilteredTypes() {
        return _ref.apply(this, arguments);
      };
    }();
    getFilteredTypes();
  }, [ticketTypesData]);
  (0, _react.useEffect)(function () {
    if (!userHasTicketingAccess) {
      setSelectedTabId("CREATE_COMMENT");
    }
  }, [userHasTicketingAccess]);
  return /*#__PURE__*/_react["default"].createElement(TicketDialog, {
    style: {
      transition: "none",
      backgroundColor: "transparent"
    },
    isSidebarExpanded: isSidebarExpanded,
    isOpen: isOpen,
    onClose: onClose,
    canOutsideClickClose: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_BODY
  }, /*#__PURE__*/_react["default"].createElement(TicketWrapper, {
    "data-testid": "AppSidebar-CreateDialogTabs"
  }, /*#__PURE__*/_react["default"].createElement(StyledTab, {
    id: "Tabs",
    selectedTabId: selectedTabId,
    onChange: function onChange(newTabId) {
      return setSelectedTabId(newTabId);
    }
  }, userHasTicketingAccess ? /*#__PURE__*/_react["default"].createElement(_core.Tab, {
    id: "CREATE_TICKET",
    "data-testid": "AppSidebar-CreateTicket",
    title: translate("AppSideBarTicketing.Ticket", "Create Ticket"),
    style: {
      backgroundColor: "white",
      alignItems: "center"
    },
    panel: /*#__PURE__*/_react["default"].createElement(_Logbook.NewLogbookTicketForm, {
      useTicketingContext: true,
      filteredTicketTypes: filteredTicketTypes,
      ticketTypes: otherTicketTypes,
      showCancel: true,
      onClose: onClose
    })
  }) : null, /*#__PURE__*/_react["default"].createElement(_core.Tab, {
    id: "CREATE_COMMENT",
    title: translate("AppSideBarTicketing.Comment", "Create Comment"),
    "data-testid": "AppSidebar-CreateComment",
    style: {
      backgroundColor: "white"
    },
    panel: /*#__PURE__*/_react["default"].createElement(_Logbook.NewLogbookCommentForm, {
      useTicketingContext: true,
      showCancel: true,
      onClose: onClose,
      style: {
        backgroundColor: "red"
      }
    })
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.FLEX_EXPANDER
  })))));
};